import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon(React.createElement("path", {
  d: "M6 19h12v2H6v-2z"
}), 'MinimizeOutlined');